export { default } from './Renegociacao25';
